export { SHARE_VIDEO_FORM_ID, shareVideoFormConfig } from './ShareVideoForm'
export { VIDEO_FORM_ID, videoFormConfig } from './VideoForm'
export {
	VIDEO_INFORMATION_FORM_ID,
	videoInformationFormConfig,
} from './VideoInformationForm'
